<template>
  <nav v-if="totalPages > 1">
    <ul class="pagination pagination-sm mb-0">
      <li class="page-item" :class="page <= 1 && 'disabled'">
        <a class="page-link" href="#" @click.prevent="go(page - 1)">&laquo;</a>
      </li>
      <li v-for="p in pages" :key="p" class="page-item" :class="p === page && 'active'">
        <a class="page-link" href="#" @click.prevent="go(p)">{{ p }}</a>
      </li>
      <li class="page-item" :class="page >= totalPages && 'disabled'">
        <a class="page-link" href="#" @click.prevent="go(page + 1)">&raquo;</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'ReportPagination',
  props: {
    total: { type: Number, default: 0 },
    perPage: { type: Number, default: 15 },
    page: { type: Number, default: 1 },
  },
  computed: {
    totalPages() { return Math.ceil(this.total / this.perPage) },
    pages() {
      const p = this.page
      const t = this.totalPages
      const w = 2
      const start = Math.max(1, p - w)
      const end = Math.min(t, p + w)
      const arr = []
      if (start > 1) { arr.push(1); if (start > 2) arr.push('...') }
      for (let i = start; i <= end; i++) arr.push(i)
      if (end < t) { if (end < t - 1) arr.push('...'); arr.push(t) }
      return arr
    },
  },
  methods: {
    go(p) {
      if (p === '...' || p < 1 || p > this.totalPages || p === this.page) return
      this.$emit('update:page', p)
      this.$emit('change', p)
    },
  },
}
</script>
